export default __webpack_public_path__ + "9d7192f1a5bc8ca21c2f829a5aef4fcb.png";